// luma.gl
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
import { Resource } from "./resource.js";
/**
 * A compiled and linked shader program for compute
 */
export class ComputePipeline extends Resource {
    static defaultProps = {
        ...Resource.defaultProps,
        shader: undefined,
        entryPoint: undefined,
        constants: {},
        shaderLayout: undefined
    };
    get [Symbol.toStringTag]() {
        return 'ComputePipeline';
    }
    hash = '';
    constructor(device, props) {
        super(device, props, ComputePipeline.defaultProps);
    }
}
